// @mui icons
// import FacebookIcon from "@mui/icons-material/Facebook";
// import TwitterIcon from "@mui/icons-material/Twitter";
// import GitHubIcon from "@mui/icons-material/GitHub";
// import YouTubeIcon from "@mui/icons-material/YouTube";

// Material Kit 2 React components
import Grid2 from "@mui/material/Unstable_Grid2";
import MKTypography from "./components/MKTypography";

// Images
import logoHKH from "./assets/images/logos/logo_dark.webp";
import aws from "./assets/images/logos/poweredbyaws.png";
import air from "./assets/images/logos/logo-s_ktyeng.png";
import igsnrr from "./assets/images/logos/igsnrr.png";
import cbas from "./assets/images/logos/cbas.png";
import icimod from "./assets/images/logos/ICIMOD-Logos/ICIMOD Master logo_Transparent-White.png";

const date = new Date().getFullYear();

export default {
  brand: {
    name: "Hindu Kush Himalayan Sustainable Development Monitoring and Assessment(dev)",
    image: logoHKH,
    route: "/home",
  },
  socials: [
    // {
    //   icon: <FacebookIcon />,
    //   link: "https://www.facebook.com/CreativeTim/",
    // },
    // {
    //   icon: <TwitterIcon />,
    //   link: "https://twitter.com/creativetim",
    // },
  ],
  menus: [
    // {
    //   name: "company",
    //   items: [{ name: "about us", href: "https://www.creative-tim.com/presentation" }],
    // },
  ],
  links: {
    air: {
      name: "air",
      icon: air,
      alt: "Aerospace Information Research Institute",
      href: "http://english.aircas.ac.cn/",
    },
    cbas: {
      name: "cbas",
      icon: cbas,
      alt: "International Research Center of Big Data for Sustainable Development Goals",
      href: "http://www.cbas.ac.cn/",
    },
    igsnrr: {
      name: "igsnrr",
      icon: igsnrr,
      alt: "Institute of Geographic Sciences and Natural Resources Research, CAS",
      href: "http://english.igsnrr.cas.cn/",
    },
    icimod: {
      name: "icimod",
      icon: icimod,
      alt: "International Centre for Integrated Mountain Development",
      href: "https://www.icimod.org/",
    },
  },

  aws: {
    name: "AWS",
    image: aws,
    alt: "Powered by AWS Cloud Computing",
    href: "https://aws.amazon.com/what-is-cloud-computing",
  },
  copyright: (
    <Grid2 container xs={12} sx={{ mb: 0, textAlign: "center" }}>
      <Grid2 item xs={12}>
        <MKTypography variant="body2" color="white" fontWeight="regular">
          Institute of Geographic Sciences and Natural Resources Research, CAS
        </MKTypography>
      </Grid2>
      <Grid2 item xs={12}>
        <MKTypography variant="body2" color="white" fontWeight="regular">
          Aerospace Information Research Institute, CAS
        </MKTypography>
      </Grid2>
      <Grid2 item xs={12}>
        <MKTypography variant="body2" color="white" fontWeight="regular">
          All rights reserved. Copyright &copy; {date}
        </MKTypography>
      </Grid2>
    </Grid2>
  ),
};
